import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { formValueSelector, isValid } from 'redux-form';
import { PASSWORD_UPDATE_FORM_NAME, PERMISSION, VENUE_SOURCE } from 'constants/logic';
import { userHasPermission } from 'helpers/core';
import { selectActiveVenue, selectUserVenues, selectUserInfo } from 'selectors/general';
import { getTermsUrl, makePath } from 'helpers/link-generation';
import { locales } from 'helpers/supported-locales';
import { userInfo } from 'store/saga/entities/bound';
import Settings from './Settings';
import { logOutAction, updateLocale, updatePassword } from './Settings.saga';
import { selectEmailBounceStatus } from './Settings.selectors';

export const shouldShowFrontdeskLink = (venueId, venueList, user) => {
  const source = (venueList.find(v => v.venueId === venueId) || {}).venueSource;
  const canMigrateToFrontDesk = userHasPermission(user, PERMISSION.CAN_MIGRATE_TO_FRONTDESK);
  return [VENUE_SOURCE.CLASSTIVITY, VENUE_SOURCE.MSINVENTORY].includes(source) && canMigrateToFrontDesk;
};

export const mapStateToProps = (state, ownProps) => {
  const { intl } = ownProps;
  const isLoaded = userInfo.loaded(state);
  const user = selectUserInfo(state);
  const { venueId: activeVenueId } = selectActiveVenue(state);
  const venuesList = selectUserVenues(state);
  const { locale } = intl;
  const brazeEmailIsBounced = selectEmailBounceStatus(state);

  // password update form
  const passwordSubmittable = isValid(PASSWORD_UPDATE_FORM_NAME)(state);
  const enteredPassword = formValueSelector(PASSWORD_UPDATE_FORM_NAME)(state, 'password') || '';

  return {
    isLoaded,
    password: enteredPassword,
    venueId: activeVenueId,
    languages: locales,
    standardTermsUrl: getTermsUrl(venuesList, activeVenueId),
    venues: venuesList,
    passwordSubmittable,
    frontdeskUrl: makePath.pike13(activeVenueId),
    showFrontdeskLink: shouldShowFrontdeskLink(activeVenueId, venuesList, user),
    user,
    locale,
    brazeEmailIsBounced,
  };
};

const mapDispatchToProps = {
  handleLogout: logOutAction,
  handleChangeLocale: updateLocale,
  unboundUpdate: updatePassword,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { password, ...restState } = stateProps;
  const { unboundUpdate, ...restDispatch } = dispatchProps;

  // exclude the unbound action creators and unused state from final props
  return {
    ...restState,
    ...restDispatch,
    handlePasswordUpdate: unboundUpdate.bind(null, password),
  };
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps, mergeProps))(Settings);
